module.exports = __webpack_public_path__ + "img/garage.c45d92d5.png";